export default __webpack_public_path__ + "static/assets/7d043362c1c4cabd22aeb93b43fc5fc6.svg";